//
// Generated class ServiceChargeTag
//

/// <reference path="ServiceChargeTag_ManagedObject.ts" />

class ServiceChargeTag extends ServiceChargeTag_ManagedObject
{

}
